import { z } from 'zod';

export enum AppLobPublishStatus {
  SUBMITTED = "submitted",
  PUBLISHED = "published",
  REJECTED = "rejected",
}

export const AppLobPublishDefinitionObject = z.object({
  id: z.string().nullish(),
  version: z.string().nullish(),
  publishingState: z.nativeEnum(AppLobPublishStatus),
});

export const AppLobPublishObject = z.object({
  externalId: z.string().nullish(),
  id: z.string(),
  appDefinitions: z.array(AppLobPublishDefinitionObject).nullish().optional(),
});

export const AppLobPublish = z.object({
  value: z.array(AppLobPublishObject),
})

export type IAppLobPublish = z.infer<typeof AppLobPublish>;
export type IAppLobPublishDefinitionObject = z.infer<typeof AppLobPublishDefinitionObject>;